import script from "./ModalMessageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMessageComponent.vue?vue&type=script&setup=true&lang=js"

import "./ModalMessageComponent.vue?vue&type=style&index=0&id=02f1951c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f1951c"]])

export default __exports__